import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Checkbox } from '@/components/ui/Form/Checkbox';
/**
 * 「全てのコンサルタントを選択する」のチェックボックス
 * @param props
 * @constructor
 */
export const RfpClientOneFileAllFormCheckboxAll = (props) => {
    const { change, changeName, className, disabled, label, values = [], viewRequests, } = props;
    const { checked, viewRequestIds } = useMemo(() => {
        // IDを抽出
        const allValues = viewRequests.map(({ id }) => id);
        return {
            // 全てチェック状態か
            checked: allValues.every((val) => values.includes(val)),
            viewRequestIds: allValues,
        };
    }, [viewRequests, values]);
    /**
     * 全選択／全解除を実行
     */
    const onChange = useCallback(() => {
        if (checked) {
            change(changeName, []);
        }
        else {
            change(changeName, viewRequestIds);
        }
    }, [checked, change, changeName, viewRequestIds]);
    return (_jsx(Checkbox, { checked: checked, className: className, disabled: disabled, label: label, onChange: onChange }));
};
